<div *ngIf="!expanded || criterioEvaluacionId === criterioId" class="nivel-logro_lllll" [ngClass]="{'expandida': expanded}">

  <div *ngIf="{data: checked$ | async} as checked" class="logro-container-fix">


        <div [ngClass]="{'claseNino': checked.data,'claseProfesor': criterioEvaluacionId === criterioId,
        'estiloLd': label === 'LD' && autoevaluacion.eventoMateriaAlumnoConfig.mostrarColoresEscala && (checked.data || criterioEvaluacionId === criterioId),
        'estiloL': label === 'L'   && autoevaluacion.eventoMateriaAlumnoConfig.mostrarColoresEscala && (checked.data || criterioEvaluacionId === criterioId),
        'estiloLp': label === 'LP' && autoevaluacion.eventoMateriaAlumnoConfig.mostrarColoresEscala && (checked.data || criterioEvaluacionId === criterioId),
        'estiloNl': label === 'NL' && autoevaluacion.eventoMateriaAlumnoConfig.mostrarColoresEscala && (checked.data || criterioEvaluacionId === criterioId),
        'estiloP': label === 'P'   && autoevaluacion.eventoMateriaAlumnoConfig.mostrarColoresEscala && (checked.data || criterioEvaluacionId === criterioId) }"
          (click)="onClick()">
          <div>
            <div class="users-cont">
              <img [matTooltip]="alumnoNombre" *ngIf="checked.data" [src]="imagenAlumno" matTooltip="Nombre del alumno">
              <div [matTooltip]="profeNombre" class="teacher-icon" *ngIf="criterioEvaluacionId === criterioId" [src]="imagenProfesor"
                matTooltip="Nombre del profesor">
                <mat-icon>school</mat-icon>
              </div>
            </div>
            <label class="logro-nivel-label">{{criterioEscala}}</label>
            <label class="logro-nivel-label"></label>
            <p class="logro-nivel-descriptor">{{criterioNombre}}</p>
          </div>
        </div>


  </div>
